/*!
 *  (c)(r) 2008-2023 IT-Service Robert Frunzke
 */

import { htmlspecialchars, mj_find_object_array_entry_by_key } from './util.js';
import { startProgress, stopProgress } from './progress-util.js';
import { getPreferedMaxDialogWidth, getPreferedMaxDialogHeight } from './dialog-util.js';
import { error_box } from './page-modal.js';
import { showInfoToast, showWarningToast } from './snackbar.js';
import { mj } from './page-mj.js';
import { jQuery } from '../other/jquery-hooked.js';
import { mjt } from './i18ntexts.js';

import { MTemplates } from './templates.js';
import { MThumbnails } from './thumbnails.js';


export let MVExport = function($,mj) {

	function open( media_ids ) {
		if( media_ids.length == 0 ) return;
		$('#mxp-form').dialog('destroy');

		// reset dialog
		var mxp_channel = $('#mxp-channel');
		mxp_channel.empty().hide();
		$('#mxp-c-list').hide();
		$('#mxp-channel-info').hide();
		$('#mxp-export-button').prop('disabled',true);

		// get list of export channels ...
		startProgress();
		$.postJSON('json/media/export-info', 'media_ids='+encodeURIComponent(media_ids.join(',')), function(j) {
			if( !j || !j.channels || j.channels.length==0 ) {
				$('#mxp-c-channel-hint').html(mjt('mxp-hint-no-channels-available'));
			} else {
				$('#mxp-c-channel-hint').html(mjt('mxp-hint-channel'));
				var channels=j.channels, chl=channels.length;
				for( var k=0; k<chl; ++k ) {
					var ch = channels[k];
					$('<option/>')
						.attr('value',ch.id)
						.text(ch.name)
						.appendTo(mxp_channel);
				}

				var _should_mxp_export_button_be_enabled = function() {
					if( $('#mxp-c-list').is(':hidden') ) return false;
					var exportable_nodes_count = $('#mxp-list').children('[id^=mxp-file-]').not('.disabled').length;
					return exportable_nodes_count>0;
				};
				var _update_mxp_export_button = function() {
					$('#mxp-export-button').prop('disabled',!_should_mxp_export_button_be_enabled());
				};
				$('#mxp-data-form').off().submit( function() {
					var postdata = {	channel_id: mxp_channel.val(),
						media_ids: [],
						fmts: [],
						fns: [] };
					$('#mxp-list').children('[id^=mxp-file-]').not('.disabled').each( function() {
						var file_node = $(this),
							node_mid = file_node.attr('media_id'),
							dlf_id = file_node.children('.mxp-item-menu').children('select').val(),
							fmt = 'df:'+dlf_id,
							fn = file_node.children('.mxp-item-filename').text()
							;
						postdata.media_ids.push(node_mid);
						postdata.fmts.push(fmt);
						postdata.fns.push(fn);
					});
					postdata.media_ids = postdata.media_ids.join(',');
					postdata.fmts = postdata.fmts.join(',');
					postdata.fns = postdata.fns.join(':');
					startProgress();
					$.postJSON('json/media/export-export_media', postdata, function(j2) {
						stopProgress();
						if( j2 && j2.success ) {
							$('#mxp-form').dialog('destroy');
							showInfoToast( mj.role_administrator ? mjt('mxp-export-success-admin') : mjt('mxp-export-success-nonadmin') );
						} else {
							if( j2.error ) showWarningToast(j2.error);
							error_box(mjt('mxp-export-failed-title'),mjt('mxp-export-failed-text'));
						}
					});
					return false;
				});

				mxp_channel.prepend('<option value="">'+mjt('mxp-channel-select')+'</option>').val('');
				mxp_channel.show().off().change( function() {
					var i, i2, dlf;

					// cleanup channel info view
					$('#mxp-channel-info').empty();

					// cleanup file list view
					$('#mxp-list').children('[id^=mxp-file-]').remove();
					$('#mxp-format-list').empty();

					var channel_id=$(this).val(), channel=null;
					if( channel_id==0 || (channel=mj_find_object_array_entry_by_key(channels,'id',channel_id))===null ) {
						$('#mxp-c-list').hide();
						$('#mxp-channel-info').hide();
					} else {

						// build channel info view
						var rd_tree_id = channel.recursive_dirs_tree_id || 0,
							rd_tree_name = channel.recursive_dirs=='1' ? ( mj.trees[rd_tree_id].name || 'unknown' ) : '';
						$('#mxp-channel-info')
							.html(	 mjt('exp-ch-target-url','!')+': '+htmlspecialchars(channel.target_url)+'<br />'
									+mjt('exp-ch-recursive-dirs','!')+': '+( channel.recursive_dirs=='1' ? mjt('exp-ch-recursive-dirs-1','!')+': <i>'+htmlspecialchars(rd_tree_name)+'</i>' : mjt('exp-ch-recursive-dirs-0','!') ) )
							.show();

						// build file list view
						var media_class_count = {}; // hash mc=>cnt, ..
						var _update_mc_format_select = function() {
							// get selected formats & update "download filenames" of items
							var dlfs_by_mc = {}; // hash mc=>hash(dlf_id=>1,dlf_id=>1,..), ..
							$('#mxp-list').children('[id^=mxp-file-]').each( function() {
								var file_node = $(this);
								var node_mid = file_node.attr('media_id');
								var node_mc = j.meta && j.meta[node_mid] && j.meta[node_mid][-1] ? j.meta[node_mid][-1][0] : 0;
								var fn;
								if( file_node.hasClass('disabled') ) {
									fn = '-';
								} else {
									var dlf_id = file_node.children('.mxp-item-menu').children('select').val();
									if( !dlfs_by_mc.hasOwnProperty(node_mc) ) dlfs_by_mc[node_mc] = {};
									dlfs_by_mc[node_mc][dlf_id] = 1 + ( dlfs_by_mc[node_mc].hasOwnProperty(dlf_id) ? dlfs_by_mc[node_mc][dlf_id] : 0 );
									fn = j.download_filenames[node_mid] && j.download_filenames[node_mid][dlf_id] ? j.download_filenames[node_mid][dlf_id] : '-';
								}
								// update filename display
								file_node.children('.mxp-item-filename').text(fn).end();
							} );
							// update format selection boxes
							var avl_media_id_count = $('#mxp-list > div[id^=mxp-file-] > .mxp-item-menu > select').length;
							$('#mxp-format-box').toggle( avl_media_id_count>1 );
							if( avl_media_id_count>1 ) {
								for( var mc in media_class_count ) {
									if( media_class_count[mc]==0 || !dlfs_by_mc.hasOwnProperty(mc) ) {
										$('#mxp-format-'+mc).remove();
									} else {
										var fmt_mc_sbox = $('#mxp-format-'+mc+' > select');
										var sel_dlf_cnt = Object.size(dlfs_by_mc[mc]);
										if( sel_dlf_cnt==1 ) {
											// only one dlf selected...
											if( fmt_mc_sbox.children('option[value=0]').length ) fmt_mc_sbox.prop('options').length --; // IE7 compatible way
											for( var dlf_id in dlfs_by_mc[mc] ) {
												if( !dlfs_by_mc[mc].hasOwnProperty(dlf_id) ) continue;
												fmt_mc_sbox.val(dlf_id);
											}
										} else {
											// multiple dlf selected...
											if( fmt_mc_sbox.children('option[value=0]').length==0 ) {
												// IE7 compatible way
												var opts = fmt_mc_sbox.prop('options');
												opts[opts.length] = new Option(mjt('mxp-format-opt-0'),'0');
												fmt_mc_sbox.children('option[value=0]').addClass('other');
											}
											fmt_mc_sbox.val('0');
										}
									}
								}
							}
							_update_mxp_export_button();
						};

						var exp_chan_perms = j.permissions.hasOwnProperty(channel.acl_action) ? j.permissions[channel.acl_action] : [];
						for( i=0; i<media_ids.length; ++i ) {
							var mid = media_ids[i];
							var can_export_to_channel = exp_chan_perms.hasOwnProperty(mid) && exp_chan_perms[mid];
							var media_class = j.meta && j.meta[mid] && j.meta[mid][-1] ? j.meta[mid][-1][0] : 0;
							var title = j.meta && j.meta[mid] && j.meta[mid][101] ? j.meta[mid][101][0] : '';
							title = title=='' ? ('ID '+mid) : (title+' (ID '+mid+')');
							var file_node = $('#mxp-template-file-item').clone(true)
								.attr({'id':'mxp-file-'+mid,'media_id':mid})
								.children('.mxp-item-media-id').text(title).end()
								.appendTo('#mxp-list')
								.show();
							// add thumbnail
							MThumbnails.createOnTarget(
								file_node.children('.mxp-item-thumb')[0],
								{
									media_id: mid,
									width: 55,
									height: 45,
									meta: j.meta[mid]||{},
									thumb_loader_anim: true,
								}
							);

							if( can_export_to_channel ) {
								// add format select options
								var fmt_sbox = file_node.children('.mxp-item-menu').children('select')
									.attr('name','media_dlf['+mid+']')
									.change(_update_mc_format_select);
								var avl_dlf_cnt = 0;
								for( i2=0; i2<j.download_formats.length; ++i2 ) {
									dlf = j.download_formats[i2];
									if( parseInt(dlf.media_class,10)==media_class && j.permissions[dlf.acl_action] && j.permissions[dlf.acl_action][mid] ) {
										$('<option />').attr('value',dlf.id).text(dlf.name).appendTo(fmt_sbox);
										avl_dlf_cnt ++;
									}
								}
								if( avl_dlf_cnt===0 ) {
									// mark as disabled
									file_node
										.addClass('disabled')
										.children('.mxp-item-menu').children('select').replaceWith(mjt('mxp-format-item-na')).end()
									;
								} else {
									// count
									media_class_count[media_class] = 1 + ( media_class_count.hasOwnProperty(media_class) ? media_class_count[media_class] : 0 );
								}
							} else {
								// can NOT export this media item to this channel at all ...
								//  clearly show this state
								// mark as disabled
								file_node
									.addClass('disabled')
									.children('.mxp-item-menu')
									.children('.label').remove().end()
									.children('select').replaceWith(mjt('mxp-item-export-on-channel-forbidden')).end()
								;
							}
							// add events handler for "item remove"
							file_node.children('.mxp-item-menu').children('.mxp-item-remove').click( function(e) {
								var fnd = $(this).closest('.mxp-file-item');
								var m = fnd.attr('media_id');
								var mc = j.meta && j.meta[m] && j.meta[m][-1] ? j.meta[m][-1][0] : 0;
								if( !fnd.hasClass('disabled') ) media_class_count[mc] --;
								fnd.remove();
								for( var x=0; x<media_ids.length; x++ ) {
									if( media_ids[x]==m ) {
										media_ids.splice(x,1);
										break;
									}
								}
								if( media_ids.length==0 ) $('#mxp-form').dialog('destroy');
								else _update_mc_format_select();
							});
						}

						// prepare format selection box
						var mc_do_len = mj.mc_display_order.length;
						for( var idx=0; idx<mc_do_len; ++idx ) {
							var mc = mj.mc_display_order[idx];
							if( mc in media_class_count && media_class_count[mc]>0 ) {
								$('#mxp-format-template').clone(true)
									.attr('id','mxp-format-'+mc)
									.find('.label').text(mj.mc_names[mc]+': ').end()
									.find('select').attr('name','mxp-format-mc-'+mc).end()
									.appendTo('#mxp-format-list')
									.show();
								for( i2=0; i2<j.download_formats.length; ++i2 ) {
									dlf = j.download_formats[i2];
									if( parseInt(dlf.media_class,10) != mc ) continue;
									$('<option />').attr('value',dlf.id).text(dlf.name).appendTo('#mxp-format-'+mc+' > select');
								}
								$('#mxp-format-'+mc+' > select').change( function() {
									var dlf_id = $(this).val();
									$('#mxp-list').children('[id^=mxp-file-]').children('.mxp-item-menu').children('select').each( function() {
										var fmt_sbox = $(this);
										if( fmt_sbox.children('option[value='+dlf_id+']').length>0 ) fmt_sbox.val(dlf_id);
									});
									window.setTimeout(_update_mc_format_select,10);
								});
							}
						}

						// show whole file list container
						$('#mxp-c-list').show();

						// trigger format selection once..
						_update_mc_format_select();
					}
				} );
			}

			// dialog max size
			var w = getPreferedMaxDialogWidth() - 40;
			if( w > 800 ) w = 800;
			var h = getPreferedMaxDialogHeight() + 0;
			if( h > 1000 ) h = 1000;
			// show dialog
			$('#mxp-form').dialog( { width:w, height:h, modal:true, resizable:false, close:function(ev, ui) {
				$(this).dialog('destroy');
			} } ).show();
			stopProgress();
		});
	}

	return {
		open: MTemplates.queryDialogHTMLWrappedFn('form_media_export',open),
	};

}(jQuery,mj); // namespace MVExport
